import { LoyaltyLevels } from "@/enums/loyalty-levels.enum";

export const hasLoyaltyLevel = (loyaltyLevel: string | undefined): boolean => 
    !!loyaltyLevel
    && loyaltyLevel !== LoyaltyLevels.None
    && Object.values(LoyaltyLevels).includes(loyaltyLevel as LoyaltyLevels);